import React, { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { userState } from "../Services/RecoilAtoms";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import {
  AddDeliveryInfo,
  DeleteDeliveryInfo,
  GetDeliveryInfo,
  UpdateDeliveryInfo,
} from "../utils/Api/ApiCalls";

const Delivery = () => {
  const currentUser = useRecoilValue(userState);
  const navigate = useNavigate();
  const [load, setLoad] = useState(true);
  const [deliveryData, setDeliveryData] = useState({});
  const [formData, setFormData] = useState({
    deliveryArea: "",
    subArea: "",
    deliveryType: "",
    price: "",
    deliveryDays: "",
  });
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [currentEditIndex, setCurrentEditIndex] = useState(null);
  const [isUpdate, setIsUpdate] = useState(false);

  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => {
    setShowModal(false);
    setIsUpdate(false);
    setFormData({
      deliveryArea: "",
      subArea: "",
      deliveryType: "",
      price: "",
      deliveryDays: "",
    });
  };

  const handleAddLocation = async () => {
    try {
      // Check if all fields in formData have values
      const { deliveryArea, subArea, deliveryType, price, deliveryDays } = formData;
      if (!deliveryArea || !subArea || !deliveryType || !price || !deliveryDays) {
        return Swal.fire({
          title: "Please fill out all fields.",
          icon: "warning",
        });
      }
  
      setIsLoading(true);
      console.log(isUpdate);
      
  
      if (isUpdate) {
        // Trigger update function if isUpdate is true...
        await handleSaveEdit();
      } else {
        // Attempt to add new delivery info if not an update...
        const res = await AddDeliveryInfo(formData);
        if (res.status === 201) {
          Swal.fire({
            title: res?.data?.message || "Location added successfully!",
            icon: "success",
          });
          setFormData({
            deliveryArea: "",
            subArea: "",
            deliveryType: "",
            price: "",
            deliveryDays: "",
          });
          await GetDeliveryLocations();
          setShowModal(false);
          navigate("/delivery");
        }
      }
    } catch (err) {
      Swal.fire({
        title: "Failed. Unable to process location data",
        text: err.message || "",
        icon: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };
  

  const GetDeliveryLocations = async () => {
    const res = await GetDeliveryInfo();
    console.log(res);
    setDeliveryData(res?.deliveryLocations);
  };

  const handleEdit = (location) => {
    setFormData(location);
    setIsUpdate(true);
    setShowModal(true);
  };

  const handleDelete = (location) => {
    setFormData(location)
    setShowDeleteModal(true);
  };

  const handleSaveEdit = async () => {
    setIsLoading(true);
    try {
      // // Replace with actual update logic
      // const updatedData = [...deliveryData];
      // updatedData[currentEditIndex] = formData;
      // setDeliveryData(updatedData);
      // setShowEditModal(false);

      const res = await UpdateDeliveryInfo(formData?.id, formData);
      console.log(res);
      
      if (res.status === 200) {
        Swal.fire("Success", "Location updated successfully!", "success");
        setFormData({
          deliveryArea: "",
          subArea: "",
          deliveryType: "",
          price: "",
          deliveryDays: "",
        });
        setShowModal(false);
        setIsUpdate(false);
        GetDeliveryLocations();
      }
    } catch (error) {
      Swal.fire("Error", "Unable to update location.", "error");
    } finally {
      setIsLoading(false);
    }
  };

  const confirmDelete = async () => {
    setIsLoading(true);
    try {
      // // Replace with actual update logic
      // const updatedData = [...deliveryData];
      // updatedData[currentEditIndex] = formData;
      // setDeliveryData(updatedData);
      // setShowEditModal(false);

      const res = await DeleteDeliveryInfo(formData?.id, formData);
      console.log(res);
      
      if (res.status === 204) {
        Swal.fire("Deleted", "Location deleted successfully!", "success");
        setFormData({
          deliveryArea: "",
          subArea: "",
          deliveryType: "",
          price: "",
          deliveryDays: "",
        });
        setShowDeleteModal(false);
        GetDeliveryLocations();
      }
    } catch (error) {
      Swal.fire("Error", "Unable to delete location.", "error");
    } finally {
      setIsLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevProfile) => ({
      ...prevProfile,
      [name]: value,
    }));
  };

  useEffect(() => {
    GetDeliveryLocations();
  }, []);

  return (
    <section className="content-main">
      <div className="row">
        <div className="col-11">
          <div className="content-header">
            <h2 className="content-title">Delivery Info</h2>
            <div>
              <button
                className="btn btn-md rounded font-sm hover-up"
                onClick={handleOpenModal}
              >
                Add new Location
              </button>
            </div>
          </div>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th scope="col">S/N</th>
                  <th scope="col">Delivery Area</th>
                  <th scope="col">Sub-Area</th>
                  <th scope="col">Delivery Type</th>
                  <th scope="col">Price (₦)</th>
                  <th scope="col">Delivery Days</th>
                  <th scope="col" className="text-end">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {deliveryData && deliveryData.length > 0 ? (
                  deliveryData.map((location, i) => (
                    <tr key={"location" + i}>
                      <td>{i + 1}</td>
                      <td>{location?.deliveryArea}</td>
                      <td>{location?.subArea}</td>
                      <td>{location?.deliveryType}</td>
                      {/* <td>{parseInt(location?.price, 10)?.toLocaleString()}</td> */}
                      <td>{location?.price.toLocaleString()}</td>
                      <td>{location?.deliveryDays}</td>
                      <td className="text-end">
                        <div className="dropdown">
                          <a
                            href="#"
                            data-bs-toggle="dropdown"
                            className="btn btn-light rounded btn-sm font-sm"
                          >
                            <i className="material-icons md-more_horiz"></i>
                          </a>
                          <div className="dropdown-menu mb-5">
                            <div
                              className="dropdown-item"
                              // to={`/view-category/${category.ID}`}
                              onClick={() => handleEdit(location)}
                            >
                              Edit
                            </div>
                            <div
                              className="dropdown-item"
                              // to={`/update-category/${category.ID}`}
                              onClick={() => handleDelete(location)}
                            >
                              Delete
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center">
                      No delivery info found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          {showModal && (
            <div className="modal-overlay">
              <div className="modal-content">
                <h2>Add Delivery Location</h2>
                <input
                  className="delivery-input"
                  type="text"
                  placeholder="Delivery Area"
                  value={formData.deliveryArea}
                  onChange={(e) =>
                    setFormData({ ...formData, deliveryArea: e.target.value })
                  }
                />
                <input
                  className="delivery-input"
                  type="text"
                  placeholder="Sub-Area"
                  value={formData.subArea}
                  onChange={(e) =>
                    setFormData({ ...formData, subArea: e.target.value })
                  }
                />
                <input
                  className="delivery-input"
                  type="text"
                  placeholder="Delivery Type"
                  value={formData.deliveryType}
                  onChange={(e) =>
                    setFormData({ ...formData, deliveryType: e.target.value })
                  }
                />
                <input
                  className="delivery-input"
                  type="number"
                  placeholder="Price"
                  value={formData.price}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      price: parseFloat(e.target.value),
                    })
                  }
                />
                <input
                  className="delivery-input"
                  type="text"
                  placeholder="Delivery Days"
                  value={formData.deliveryDays}
                  onChange={(e) =>
                    setFormData({ ...formData, deliveryDays: e.target.value })
                  }
                />
                <div className="modal-btns">
                  <div
                    onClick={handleCloseModal}
                    className="btn btn-secondary hover-up "
                  >
                    Cancel
                  </div>
                  <button
                    disabled={isLoading}
                    className="btn btn-primary"
                    onClick={handleAddLocation}
                  >
                    {isLoading ? <div className="spinner"></div> : "Save"}
                  </button>
                </div>
              </div>
            </div>
          )}
          {showDeleteModal && (
            <div className="modal-overlay">
              <div className="modal-content">
                <h2>Confirm delete </h2>
                <div className="modal-btns">
                  <div
                    onClick={() => setShowDeleteModal(false)}
                    className="btn btn-secondary hover-up "
                  >
                    Cancel
                  </div>
                  <button
                    disabled={isLoading}
                    className="btn btn-primary red"
                    onClick={confirmDelete}
                  >
                    {isLoading ? <div className="spinner"></div> : "Delete"}
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Delivery;
